
import React from "react";
import { ButtonColorful } from "@/components/ui/button-colorful";
import { redirectToEditor } from "@/utils/redirectToEditor";

interface ViewProgramButtonProps {
  programId?: string;
}

const ViewProgramButtonComponent = ({ programId }: ViewProgramButtonProps) => {
  if (!programId) return null;
  
  const handleClick = React.useCallback(() => {
    redirectToEditor(programId);
  }, [programId]);
  
  return (
    <div className="flex justify-end mt-4">
      <ButtonColorful
        label="Edit Program"
        onClick={handleClick}
        className="shadow-lg"
      />
    </div>
  );
};

// Memoize since this only needs to re-render if programId changes
export const ViewProgramButton = React.memo(ViewProgramButtonComponent);
